export default function reducer(state = {
    tour: null,
    data: null,
    redirect: false
}, action) {
    switch (action.type) {
        case "ADD_TOUR_BOOKING_DETAILS": {
            return {
                ...state,
                tour: action.tour,
                data: action.data,
                redirect: true
            }
        }
        case "CHECKOUT_REDIRECTION": {
            return {
                ...state,
                redirect: action.bool
            }
        }
        case "ADD_VEHICLE_BOOKING_DETAILS": {
            return {
                ...state,
                data: action.data,
                redirect: true
            }
        }
        default:
            break;
    }
    return state
}